import { serviceName } from '../resources/serviceConstants';
import { DEAL_STATUS_LIST } from '../resources/endPoint';

export const dealStatusList = () => {
  return {
    url: DEAL_STATUS_LIST,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const enableOrDisableDealStatus = (data) => {
  return {
    url: DEAL_STATUS_LIST,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};
